const { useEffect, useState } = require('react')

const { authedAxios } = require('../../utils')

const useMotivationalQuotes = (options = {}) => {
  const { skip } = options

  const [motivationalQuotes, setMotivationalQuotes] = useState([])
  const [motivationalQuotesCopy, setMotivationalQuotesCopy] = useState([])
  const [isLoading, setIsLoading] = useState(true)
  const [hasLoadError, setHasLoadError] = useState(false)
  const [displayLocation, setDisplayLocation] = useState('dashboard-only')

  const getMotivationalQuotes = () => {
    return authedAxios
      .get('/api/identity-settings/motivational-quotes')
      .then((res) => {
        setMotivationalQuotes(res.data.motivationalQuotes)
        setMotivationalQuotesCopy(res.data.motivationalQuotes)
        setDisplayLocation(res.data.config?.displayLocation || 'dashboard-only')
      })
      .catch((_e) => {
        setHasLoadError(true)
      })
      .finally(() => {
        setIsLoading(false)
      })
  }

  const saveMotivationalQuotes = (newVal) => {
    if (newVal) {
      setMotivationalQuotes(newVal)
    }

    return authedAxios.put('/api/identity-settings/motivational-quotes', {
      motivationalQuotes: newVal ? newVal : motivationalQuotes,
      config: { displayLocation },
    })
  }

  const reset = () => {
    setMotivationalQuotes(motivationalQuotesCopy)
  }

  useEffect(() => {
    if (!skip) getMotivationalQuotes()
  }, [])

  return {
    motivationalQuotes,
    setMotivationalQuotes,
    saveMotivationalQuotes,
    reset,
    isLoading,
    hasLoadError,
    displayLocation,
    setDisplayLocation,
  }
}

export default useMotivationalQuotes
